<script setup lang="ts">
import { PaginationComponent } from '@metapic-apps/shared'
import { ref, toRef, watch } from 'vue'

import { useGetCreatorAdvertisers } from '@/api/creator-advertisers.api'
import SearchIcon from '@/assets/icons/search.svg?component'
import CreatorAdvertiserListItem from '@/components/CreatorDetail/CreatorAdvertiserListItem.vue'
import { debounce } from '@/lib/helpers'
import { BoxComponent, FlexComponent, InputComponent, LoadingComponent, TypographyComponent } from '@/ui-library'

const props = defineProps<{
  userId: number
}>()

const searchQuery = ref('')
const serverQuery = ref('')

watch(
  searchQuery,
  debounce((value: string) => {
    serverQuery.value = value.trim()
  }, 300),
)

const { data: advertisers, totalPages, page, isLoading } = useGetCreatorAdvertisers(toRef(props, 'userId'), serverQuery)
</script>

<template>
  <BoxComponent :p="24">
    <FlexComponent direction="column" :gap="24">
      <InputComponent v-model="searchQuery" placeholder="Search advertiser" size="small" class="advertiser-search">
        <template #prefix>
          <ElIcon :size="18">
            <SearchIcon />
          </ElIcon>
        </template>
      </InputComponent>

      <LoadingComponent v-if="isLoading" :size="48" />
      <TypographyComponent v-else-if="advertisers.length === 0" variant="body-large" color="var(--secondary-48)">
        {{ serverQuery ? 'No advertisers match your search.' : 'No advertisers found.' }}
      </TypographyComponent>
      <template v-else>
        <FlexComponent direction="column" :gap="12">
          <CreatorAdvertiserListItem v-for="advertiser in advertisers" :key="advertiser.id" :item="advertiser" />
        </FlexComponent>

        <PaginationComponent v-model:current-page="page" :total-pages="totalPages" />
      </template>
    </FlexComponent>
  </BoxComponent>
</template>

<style scoped lang="scss">
.advertiser-search {
  width: min(100%, 360px);
}
</style>
